// Compute display initials for an avatar bubble.
//
// Rules:
//   "Lakshmi Devi"  → "LD"   (first letters of first two words)
//   "Govindraj"     → "GO"   (first two chars when there's no whitespace)
//   "x"             → "X"    (whatever's there, uppercased)
//   ""              → "?"    (defensive — never render an empty bubble)
//   null/undefined  → "?"
//
// Used by every picker / card that renders an initials avatar — keep in
// sync rather than copy-pasting tiny variants per component (the prior
// versions returned a single letter for one-word names, which looked
// broken on cards like "Govindraj — G").
export function initialsOf(name: string | null | undefined): string {
  if (!name) {return '?'}
  const parts = name.trim().split(/\s+/).filter(Boolean)
  if (parts.length === 0) {return '?'}
  if (parts.length === 1) {
    const sole = parts[0] ?? ''
    return sole.slice(0, 2).toUpperCase() || '?'
  }
  return (
    parts
      .slice(0, 2)
      .map((p) => p[0]?.toUpperCase() ?? '')
      .join('') || '?'
  )
}
